// AmCharts_path = "/libs/amcharts/"
import 'amcharts/amcharts'
import 'amcharts/serial'
// import 'amcharts/pie'
// import 'amcharts/funnel'
import 'amcharts/themes/light'
if (HM.locale == 'ru') {
  require('amcharts/lang/ru')
}
